/* RESPONSIBLE TEAM: team-ai-agent */
import AutomationFinAIAgentProcedureSimulationsTestRunRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/procedures/procedure/preview/simulations/test/run';

export default AutomationFinAIAgentProcedureSimulationsTestRunRoute;
